import React, { Component, createRef } from 'react'
import './Group.css'
import withLayout from '../../withLayout'
import { withRouter } from '../../withRouter'
import { CSSTransition } from 'react-transition-group'
import Ranking from '../modules/Ranking'
import Partidos from '../modules/Partidos'
import Mensajes from '../modules/Mensajes'
import GroupsContext from '../../GroupsContext'
import { Action } from '../commons/Actions'
import { MenuGroup } from '../modules/Menus'

class Group extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: 0
    }
    this.rankingRef = createRef()
    this.partidosRef = createRef()
    this.mensajesRef = createRef()
    this.handleTab = this.handleTab.bind(this)
  }
  handleTab (section) {
    this.setState({
      tab: section
    })
  }
  render () {
    return (
      <div className='group'>
        <GroupHeader groupId={this.props.match.params.id} onClick={() => this.props.history.push('/')} handleModal={this.props.handleModal} />
        <div className='group__tabs'>
          <a href='#ranking' className={this.state.tab === 0 ? 'group__tab group__tab--active' : 'group__tab'} onClick={(ev) => {
            ev.preventDefault()
            this.handleTab(0)
          }}>Ranking</a>
          <a href='#partidos' className={this.state.tab === 1 ? 'group__tab group__tab--active' : 'group__tab'} onClick={(ev) => {
            ev.preventDefault()
            this.handleTab(1)
          }}>Partidos</a>
          <a href='#mensajes' className={this.state.tab === 2 ? 'group__tab group__tab--active' : 'group__tab'} onClick={(ev) => {
            ev.preventDefault()
            this.handleTab(2)
          }}>Mensajes</a>
        </div>
        <CSSTransition
          in={this.state.tab === 0}
          nodeRef={this.rankingRef}
          classNames={'group__content'}
          timeout={800}
          mountOnEnter
          unmountOnExit>
          <div ref={this.rankingRef}>
            <Ranking groupId={this.props.match.params.id} handleModal={this.props.handleModal} />
          </div>
        </CSSTransition>
        <CSSTransition
          in={this.state.tab === 1}
          nodeRef={this.partidosRef}
          classNames={'group__content'}
          timeout={800}
          mountOnEnter
          unmountOnExit>
          <div ref={this.partidosRef}>
            <Partidos groupId={this.props.match.params.id} />
          </div>
        </CSSTransition>
        <CSSTransition
          in={this.state.tab === 2}
          nodeRef={this.mensajesRef}
          classNames={'group__content'}
          timeout={800}
          mountOnEnter
          unmountOnExit>
          <div ref={this.mensajesRef}>
            <Mensajes groupId={this.props.match.params.id} />
          </div>
        </CSSTransition>
      </div>
    )
  }
}

class GroupHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menu: null
    }
    this.menuRef = createRef()
  }
  render () {
    return (
      <GroupsContext.Consumer>
        {(groups) => {
          const data = groups.find((group) => group.id === this.props.groupId)
          let cover, title, admin, mode
          if (data) {
            cover = data.cover
            title = data.titulo
            admin = data.admin
            mode = data.mode
          }
          return (
            <div className='group__header'>
              <div className='group__header__actions'>
                <Action color icon='arrow_back' onClick={this.props.onClick} />
              </div>
              <div className='group__header__info'>
                <div className='group__header__cover'>{cover && <img alt='Cover' src={cover} />}</div>
                <div className='group__header__info__col'>
                  <div className='group__header__title'>{title}</div>
                  <div className='group__header__mode'>{mode}</div>
                </div>
              </div>
              <div className='group__header__actions'>
                <Action color icon='more_horiz' onClick={() => this.setState({ menu: true })} />
              </div>
              <CSSTransition
                in={this.state.menu}
                nodeRef={this.menuRef}
                classNames={'menu'}
                timeout={200}
                mountOnEnter
                unmountOnExit>
                <div ref={this.menuRef}>
                  <MenuGroup
                    id={this.props.groupId}
                    title={title}
                    cover={cover}
                    admin={admin}
                    mode={mode}
                    closeMenu={() => this.setState({ menu: null })}
                    handleModal={this.props.handleModal}
                  />
                </div>
              </CSSTransition>
            </div>
          )
        }}
      </GroupsContext.Consumer>
    )
  }
}

export default withRouter(withLayout(Group, true, true))
